import React, { useState } from "react";
import { auth, db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import "../styles/Auth.css";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [isSignUp, setIsSignUp] = useState(true); // Default to signup for admin creation
  const navigate = useNavigate();

  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (isSignUp) {
        // Admin Creation Logic
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        await setDoc(doc(db, "admins", user.uid), { // Store in 'admins' collection
          name,
          email,
        });

        navigate("/admin-dashboard"); // Redirect to dashboard after admin creation
      } else {
        // Admin Login Logic
        await signInWithEmailAndPassword(auth, email, password);
        navigate("/admin-dashboard"); // Redirect to dashboard after admin login
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-container">
      <h2>{isSignUp ? "Create Admin" : "Admin Login"}</h2> {/* Updated title */}
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleAuth}>
        {isSignUp && (
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        )}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit">{isSignUp ? "Create Admin" : "Admin Login"}</button> {/* Updated button text */}
      </form>
      <p className="toggle-text" onClick={() => setIsSignUp(!isSignUp)}>
        {isSignUp ? "Already have an admin account? Login" : "Don't have an admin account? Create Admin"} {/* Updated toggle text */}
      </p>
    </div>
  );
};

export default Auth;